exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/srv0wme.css);", ""]);

// module
exports.push([module.id, "/*\r\n$breakpoint argument choices:\r\n- xs\r\n- sm\r\n- md\r\n- lg\r\n- xl\r\n*/\n.profileFull[data-v-a4ade38a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  height: 600px;\n}\n", ""]);

// exports
